import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useToggleStarStandardizationProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    return await axios.post(`/standardization/${id}/star`);
  });

  const toggleStarProject = (projectId) => {
    mutate(projectId, {
      onSuccess: (res) => {
        // queryClient.invalidateQueries('standardizationProjects', { exact: true });
        queryClient.setQueryData('standardizationProjects', (projects) => {
          const projectToUpdate = projects.find((p) => p.id === projectId);
          if (!projectToUpdate) return projects;
          projectToUpdate.starred = res.data;
          return projects;
        });
        let toastMsg;
        if (res.data) {
          toastMsg = 'Successfully put the project in favourites!';
        } else {
          toastMsg = 'Successfully removed the project from favourites!';
        }
        toast.success(toastMsg);
      },
      onError: (err) => {
        toast.error(err.message || 'Error! Try again later.');
      },
    });
  };

  return {
    toggleStarProject,
    isLoading,
  };
};

export default useToggleStarStandardizationProject;
